function Partners() {
  this.API = 'https://admin.zrp-site.tools/wp-json/zrp-point-of-sale/v2/site/';

  this.categories = [];

  this.groupCategories = [
    {
      id: 1,
      name: 'Hospitality ',
      cats: ['backery','gallery','hotel','museum','pizzeria','restaurant','theatre','bistro','cafe','cinema','pharmacy','concert_hall']
    },{
      id: 2,
      name: 'Bars & Nightlife',
      cats: ['bar','club']
    },{
      id: 3,
      name: 'Sports & Lifestyle',
      cats: ['fitness']
    },{
      id: 4,
      name: 'Beauty & Wellness',
      cats: ['salon', 'SPA']
    }
  ];

  this.rootTag = document.querySelector('.zrp-partners');
  this.contentTag = document.querySelector('.zrp-partners__content');
  this.citiesTag = document.querySelector('.zrp-partners__cities');
  this.filtersTag = document.querySelector('.zrp-partners__filters');

  // Filter default
  this.defaultFilter = 'iso_code~eu';

  // Filter API default
  this.filter = this.defaultFilter;

  // State of tags
  this.filtersState = [];

  // State of groups
  this.groupsState = [];

  // Location from settings
  if (this.rootTag) {
    let locCode = this.rootTag.dataset.locationCode;
    if (locCode) {
      this.filter = `iso_code~${locCode}`;
    }
  }

  /**
   * Start work
   */
  this.init = function () {
    this.drawCities();
    this.drawPartners();
    //this.drawCategories();
    this.drawGroupOfCategories();
    this.events();
  };

  /**
   *  Get data from server
   * @param {string} path
   * @param {object} params
   * @returns
   */
  this.getData = async function (path, params = {}) {
    let str = `${this.API}${path}`;

    if (Object.keys(params).length > 0) {
      str = `${str}?${new URLSearchParams(params)}`;
    }

    let response = await fetch(str);

    if (response.ok) {
      return await response.json();
    }
  };

  /**
   * Get filter partners
   * @returns
   */
  this.getPartners = async function () {
    const partners = await this.getData('partners', {
      filter: this.filter,
      use_limit: 0,
    });
    return partners;
  };

  /**
   * Get cities
   * @returns
   */
  this.getCities = async function () {
    const cities = await this.getData('partners/cities', {
      lang: 'en',
      filter: this.filter,
    });
    return cities;
  };

  /**
   * Get categories
   * @returns
   */
  this.getCategories = async function () {
    const categories = await this.getData('partners/categories', {
      lang: 'en',
      filter: this.filter,
    });
    return categories;
  };

  /**
   * Get object from filter string
   * @returns object
   */
  this.getFilter = function () {
    let filter = {};
    let list = this.filter.split('|');
    for (let i = 0; i < list.length; i++) {
      let item = list[i].split('~');
      if (item.length === 2) {
        filter[item[0]] = item[1];
      }
    }
    return filter;
  };

  /**
   * Set values in the filter string
   * @param {string} key
   * @param {string} value
   */
  this.setFilter = function (key, value) {
    let result = [];
    let filter = this.getFilter();

    if (value === null) {
      delete filter[key];
    }

    if (value) {
      filter[key] = value;
    }

    let keys = Object.keys(filter);
    for (let i = 0; i < keys.length; i++) {
      let key_name = keys[i];
      let key_value = filter[key_name];
      result.push(`${key_name}~${key_value}`);
    }
    return result.join('|');
  };

  /**
   * Creates a DOM element given the parameters
   * @param {string} name
   * @param {array} attrs
   * @returns
   */
  this.createElement = function (name, attrs) {
    const element = document.createElement(name);
    attrs &&
      attrs.forEach(function (attr) {
        if (attr['type']) {
          element.dataset[attr.name] = attr.value;
        } else {
          element[attr.name] = attr.value;
        }
      });
    return element;
  };

  /**
   * Output of the list of partners
   */
  this.drawPartners = async function () {
    const divs = [];
    const partners = await this.getPartners();

    let inner = this.createElement('div', [
      {
        name: 'className',
        value: 'zrp-partners__content-inner',
      },
    ]);

    if (this.contentTag && partners.data.length > 0) {
      for (let i = 0; i < partners.data.length; i++) {
        let item = partners.data[i];

        // Item
        const div = this.createElement('div', [
          {
            name: 'className',
            value: 'zrp-partners__item',
          },
        ]);

        // Link
        const link = this.createElement('a', [
          {
            name: 'href',
            value: item.web,
          },
          {
            name: 'title',
            value: item.name,
          },
          {
            name: 'target',
            value: '_blank',
          },
          {
            name: 'className',
            value: 'zrp-partners__link',
          },
        ]);

        // Image
        const image = this.createElement('img', [
          {
            name: 'src',
            value: item.logo,
          },
          {
            name: 'loading',
            value: 'lazy',
          },
          {
            name: 'alt',
            value: item.name,
          },
          {
            name: 'width',
            value: '600',
          },
          {
            name: 'height',
            value: '600',
          },
          {
            name: 'className',
            value: 'zrp-partners__image',
          },
        ]);

        link.appendChild(image);
        div.appendChild(link);
        inner.appendChild(div);
      }

      $(this.contentTag).html(inner);

      $(this.contentTag)
        .find('.zrp-partners__image')
        .css({ opacity: 0, visibility: 'visible' })
        .animate({ opacity: 1 }, 300);
    } else {
      // const cityName = this.citiesTag.options[this.citiesTag.selectedIndex].text;

      this.contentTag.innerHTML = `<p style="margin: 40px 0;">Unfortunately, in the selected region, for such categories, there are no our partners</p>`;
    }
  };

  /**
   * Output to the list of cities
   */
  this.drawCities = async function () {
    const cities = await this.getCities();

    if (this.citiesTag && cities.length > 0) {
      let options = [];

      let wrapper = this.createElement('div');

      const defOption = this.createElement('option', [
        {
          name: 'value',
          value: 'all',
        },
      ]);

      defOption.innerText = 'All cities';
      wrapper.appendChild(defOption);
      options.push(wrapper.innerHTML);

      for (let i = 0; i < cities.length; i++) {
        let city = cities[i];

        if (city.city_name) {
          wrapper = this.createElement('div');

          const option = this.createElement('option', [
            {
              name: 'value',
              value: city.city_id,
            },
          ]);

          option.innerText = city.city_name;
          wrapper.appendChild(option);
          options.push(wrapper.innerHTML);
        }
      }

      this.citiesTag.innerHTML = options.join('');
    }
  };

  /**
   * Categories
   */
  this.drawCategories = async function () {
    
    this.categories = await this.getCategories();

    if (this.filtersTag && this.categories.length > 0) {
      let filters = [];

      this.categories.sort(function (a, b) {
        if (a['category_name'] < b['category_name']) {
          return -1;
        }
        if (a['category_name'] > b['category_name']) {
          return 1;
        }
        return 0;
      });

      for (let i = 0; i < this.categories.length; i++) {
        let item = this.categories[i];

        let classNames =
          this.filtersState.indexOf(item.category_id) > -1
            ? 'zrp-partners__filter-item zrp-partners__filter-item--active'
            : 'zrp-partners__filter-item';

        let wrapper = this.createElement('div');
        const category = this.createElement('button', [
          {
            name: 'type',
            value: 'button',
          },
          {
            type: 'data',
            name: 'value',
            value: item.category_id,
          },
          {
            name: 'className',
            value: classNames,
          },
        ]);

        category.innerText = item.category_name;
        wrapper.appendChild(category);
        filters.push(wrapper.innerHTML);
      }

      this.filtersTag.innerHTML = filters.join('');
    }
  };

  /**
   * Group of categories
   */
  this.drawGroupOfCategories = async function () {

    this.categories = await this.getCategories();

    if (this.filtersTag && this.categories.length > 0) {

      let filters = [];

      this.categories.sort(function (a, b) {
        if (a['category_name'] < b['category_name']) {
          return -1;
        }
        if (a['category_name'] > b['category_name']) {
          return 1;
        }
        return 0;
      });

      for (let i = 0; i < this.groupCategories.length; i++) {

        let item = this.groupCategories[i];

        let classNames =
          this.groupsState.indexOf(item.category_id) > -1
            ? 'zrp-partners__filter-item zrp-partners__filter-item--active'
            : 'zrp-partners__filter-item';

        let wrapper = this.createElement('div');

        const group = this.createElement('button', [
          {
            name: 'type',
            value: 'button',
          },
          {
            type: 'data',
            name: 'value',
            value: item.id,
          },
          {
            name: 'className',
            value: classNames,
          },
        ]);

        group.innerText = item.name;
        wrapper.appendChild(group);
        filters.push(wrapper.innerHTML);

      }

      this.filtersTag.innerHTML = filters.join('');

    }
  }

  /**
   * Events
   */
  this.events = function () {
    const self = this;

    // Change city
    if (this.citiesTag) {
      this.citiesTag.onchange = function (e) {
        const city_id = e.target.value;

        if (city_id === 'all') {
          self.filter = self.setFilter('city_id', null);
        } else {
          self.filter = self.setFilter('city_id', city_id);
        }

        self.drawPartners();
      };
    }

    // Cloud tags
    if (this.filtersTag) {
      $(this.filtersTag).delegate('button', 'click', function () {
        let value = $(this).data('value');
        let index = self.groupsState.indexOf(value);
        if (index === -1) {
          self.groupsState.push(value);
          $(this).addClass('zrp-partners__filter-item--active');
        } else {
          self.groupsState.splice(index, 1);
          $(this).removeClass('zrp-partners__filter-item--active');
        }
        
        for (let i = 0; i < self.groupCategories.length; i++) {
          const { id, cats} = self.groupCategories[i];
          if (value == id) {
            if (index === -1) {
              self.filtersState = [...self.filtersState, ...cats];
            } else {
                for (let f = 0; f < cats.length; f++) {
                self.filtersState.splice(self.filtersState.indexOf(cats[f]),1);
                }
            }
            break;
          }
        }

        self.filter = self.setFilter(
          'category_id',
          self.filtersState.length > 0 ? self.filtersState.join(',') : null
        );

        self.drawPartners();
      });
    }
  };
}

$(document).ready(function () {
  new Partners().init();
});
